module.exports = __webpack_public_path__ + "static/img/register-bg.d9a48dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/register-bg.png
// module id = sUdz
// module chunks = 1